  /**
   * Replaces parts of a slug based on a lookup object, with optional exceptions.
   * 
   * @param {string} slug - The slug to be replaced.
   * @param {Record<string, string>} [lookUp={}] - An object with keys to replace in the slug and their corresponding values.
   * @param {string[]} [exceptions=[]] - An array of strings that should not be replaced.
   * @returns {string} The updated slug with replacements applied.
   */
const replaceSlug = (slug, lookUp = {}, exceptions = []) => {
  if (exceptions.length !== 0 && exceptions.includes(slug)) {
    return slug;
  }

  if (Object.keys(lookUp).length !== 0) {
    const re = new RegExp(Object.keys(lookUp).join('|'), 'gi');
    return slug.replace(re, matched => {
      return lookUp[matched.toLowerCase()];
    });
  }

  return slug;
};

module.exports = replaceSlug;
